module.exports = __webpack_public_path__ + "static/media/coin.8bda62f9.png";